var MDB = window.MDB || {};;
MDB.SettingsApi = MDB.SettingsApi || {};
MDB.SettingsApi.Index = MDB.SettingsApi.Index || {};

(function() {

    var _config,
        _targetsTable;

    $.extend(MDB.SettingsApi.Index, {
    	boot: function(config) {
    		_config = config;
    		_targetsTable = $('#targets-table').DataTable({  "dom": 'frtipl' });
            $('.dataTables_filter').addClass('pull-left');

            $('[data-action="refresh"]').click(function(e) {
                var me = $(this);

                var id = me.parents('tr').first().find('input').first().val();

                MDB.sendAjaxRequest(config.refreshUrl, {id: id}, 'POST').done(function(response) {
                    if(response.value != null) {
                        var expiresAt = response.value != 0 ? 
                            moment(new Date(response.value)).format('DD-MM-YYYY HH:mm:ss (UTC)') : 
                            "";

                        var expiresColumn = me.parents('td').first().prev();
                        expiresColumn.text(expiresAt);
                        expiresColumn.prev().html('<span class="text-success">'+ MDB.loadResourceString('SettingsApi_Index_Token_Active_Text') +'</span>');
                        MDB.Notify.bootstrapSuccess('Token refreshed successfully.');
                    }
                    
                });
            });
    	},
    	deleteTarget: function(button) {
    		var me = $(button);
    		var row = me.parents('tr').first();
    		var id = row.find('input').first().val();

    		MDB.prompt(
                MDB.loadResourceString('SettingsApi_Target_Delete_Prompt_Title'), 
                MDB.loadResourceString('SettingsApi_Target_Delete_Prompt_Body'), 
            
                function(ok){
                    if (ok) {
                        MDB.sendAjaxRequest(_config.deleteUrl, { id: id }, 'POST').done(function(response) {
                            if(response.success) {
                                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('SettingsApi_Target_Delete_Success'));
                                _targetsTable.row(row).remove().draw();
                            }
    				});
                    }
                });
    	}
    });
})();